import { ApplicationConfig, provideZoneChangeDetection, provideAppInitializer, inject } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHighcharts } from 'highcharts-angular';

import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { onboardingRevalidationInterceptor } from './features/onboarding/engine/onboarding-revalidation.interceptor';
import { provideOnboarding } from './features/onboarding/onboarding.providers';
import { LanguageService } from './core/services/language.service';
import { WHATSAPP_ICON_NAME, WHATSAPP_ICON_SVG } from './core/icons/custom-icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // Scroll to top on every navigation (fixes mobile scroll position after login redirect)
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top', anchorScrolling: 'enabled' })),
    provideHttpClient(
      withInterceptors([
        authInterceptor,
        errorInterceptor,
        onboardingRevalidationInterceptor
      ])
    ),
    provideOnboarding(),
    provideAnimationsAsync(),
    provideNativeDateAdapter(),
    provideHighcharts(),
    provideTranslateService({
      fallbackLang: 'pt',
    }),
    provideTranslateHttpLoader({
      prefix: './locale/',
      suffix: '.json',
      useHttpBackend: true,
    }),
    provideAppInitializer(() => {
      const languageService = inject(LanguageService);
      return languageService.init();
    }),
    provideAppInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);
      iconRegistry.addSvgIconLiteral(WHATSAPP_ICON_NAME, sanitizer.bypassSecurityTrustHtml(WHATSAPP_ICON_SVG));
    })
  ]
};
